// Dependencies
import React, { useState, useEffect, useMemo } from "react";

// Modules

// App
import { apiEndpoints } from "../../config";

import PostEdit from "../../partials/posts/postEdit";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import { Row, Col } from "react-bootstrap";
import { Typography, TextField } from "@mui/material";

export default function CompanyDirectoryEdit() {
  const [officeHours, setOfficeHours] = useState(null);
  const [address, setAddress] = useState("");
  const [post, setPost] = useState(null);

  const extraFields = useMemo(() => {
    const _officeHours = officeHours
      ? { field_opening_times: officeHours }
      : {};
    const _address = address ? { field_address: address } : {};
    return {
      ..._officeHours,
      ..._address,
    };
  }, [officeHours, address]);

  useEffect(() => {
    if (!post) return;
    if (post.field_opening_times) {
      setOfficeHours(post.field_opening_times);
    }
    if (post.field_address) {
      setAddress(post.field_address);
    }
  }, [post]);

  return (
    <PostEdit
      entityType={"company_directory"}
      apiEndpoint={apiEndpoints.company_directory}
      screenClassName={"company-directory"}
      categoryTitle={"Company Directory category"}
      categoryName={"field_company-directory_category"}
      targetVid={"company_directory_categories"}
      returnRoute={"/company_directory-creator"}
      backBtnText={"Company Directory Library"}
      previewRoute={"/company_directory/preview"}
      logCustomEventType={"company_directory"}
      featuredImageEnabled={true}
      extraFields={extraFields}
      featuredImageFiles={{
        aspectRatio: 1,
      }}
      setEntityPost={(_post) => {
        setPost(_post);
      }}
      editorProps={{
        title: true,
        subtitle: true,
        body: true,
        list: true,
        table: true,
        image: true,
        video: true,
        embed: true,
        rule: true,
        buttonGroup: true,
        chart: true,
        map: true,
        contactGroup: true,
      }}
      imageBlockEnabled={true}
    >
      <Row className="my-3">
        <Col xs={5} sm={3}>
          <Row className="ps-4 ms-2">
            <Col xs={"auto"} className="pe-3">
              <AccessTimeIcon color="clientPrimary" />
            </Col>
            <Col className="px-0">
              <Typography
                owner="client"
                variant="body2"
                color="clientText.main"
                lh="x-wide"
                weight="bold"
                singles="true"
              >
                Office hours:
              </Typography>
            </Col>
          </Row>
        </Col>

        <Col xs={7} sm={9} className="flex-grow-1 ps-4">
          <Row>
            <Col>
              <TextField
                className="w-100"
                label="Enter office hours"
                variant="outlined"
                value={officeHours}
                onChange={(e) => setOfficeHours(e.target.value)}
                size="small"
              />
            </Col>
          </Row>
        </Col>
      </Row>
      <Row className="mb-3">
        <Col xs={5} sm={3}>
          <Row className="ps-4 ms-2">
            <Col xs={"auto"} className="pe-3">
              <LocationOnOutlinedIcon color="clientPrimary" />
            </Col>
            <Col className="px-0">
              <Typography
                owner="client"
                variant="body2"
                color="clientText.main"
                lh="x-wide"
                weight="bold"
                singles="true"
              >
                Location:
              </Typography>
            </Col>
          </Row>
        </Col>

        <Col xs={7} sm={9} className="flex-grow-1 ps-4">
          <Row>
            <Col>
              <TextField
                className="w-100"
                label="Enter address"
                variant="outlined"
                value={address}
                onChange={(e) => setAddress(e.target.value)}
                size="small"
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </PostEdit>
  );
}
